module.exports = __webpack_public_path__ + "static/media/sidebarindicator.4eadb0a6.png";